// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  const { id: varId } = evt.detail.variant;
  const prodId = evt.detail.product_id;
  if (document.querySelectorAll("[data-inv-policy]").length) {
    document.querySelectorAll("[data-inv-policy]").forEach((el) => {
      el.classList.add("hidden");
      const klaviyoTrigger = el.querySelector(".klaviyo-bis-trigger")
      if (klaviyoTrigger) {
        klaviyoTrigger.style.display = "none";
      }
    });
  }
  document
    .querySelector(`[data-policy-id="${varId}"]`)
    ?.classList.remove("hidden");

  const klaviyoTrigger = document
    .querySelector(`[data-policy-id="${varId}"] .klaviyo-bis-trigger`)
  if (klaviyoTrigger) {
    klaviyoTrigger.style.display = "block";
  }

  //product badges
  if (document.querySelectorAll(".product .product-badge").length) {
    document
      .querySelectorAll(".product .product-badge")
      .forEach((el) => el.classList.add("hidden"));
    if (
      document.querySelectorAll(
        `.product .product-badge[data-variant-id="${varId}"]`,
      ).length
    ) {
      document
        .querySelectorAll(`.product .product-badge[data-variant-id="${varId}"]`)
        .forEach((el) => el.classList.remove("hidden"));
    }
  }

  if (document.querySelector(`[data-section-type="product"]`)) {
    let currentProductEle = document.querySelector(
      `[data-section-type="product"][data-product-id='${prodId}']`,
    );
    if (currentProductEle.querySelector(`.product__variants-wrapper`)) {
      currentProductEle
        .querySelector(`.product__variants-wrapper`)
        .setAttribute(`data-current-variant-id`, varId);
    }
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {});
